var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('d-button',{class:_vm.additionalClasses,on:{"click":function($event){return _vm.$modal.show('productQrModal')}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }